import { mapGetters } from 'vuex';
const CHANGED_NOTICE_KEY = 'xmed_password_changed_notice';

/**
 * Lejárt jelszó: kényszerített csere.
 *
 * A gyökérben, nem a layoutban — ugyanazért, amiért az átjelentkezés-sáv: a hibaoldalnak
 * és a belépő képernyőnek nincs fejléce, ott a képernyő eltűnne, és a felhasználó egy
 * olyan felületen ragadna, ami minden hívásra 423-at kap.
 *
 * A KÉNYSZER nem ezé a komponensé: a szerver utasít el mindent, amíg a jelszó lejárt. Ez
 * a képernyő csak megmondja, miért, és megmutatja a kiutat.
 */
export default {
  name: 'PasswordExpiryGate',
  data() {
    return {
      saving: false,
      form: {
        password: null,
        new: null,
        new_confirmation: null
      }
    };
  },
  mounted() {
    let notice = null;
    try {
      notice = window.sessionStorage.getItem(CHANGED_NOTICE_KEY);
      window.sessionStorage.removeItem(CHANGED_NOTICE_KEY);
    } catch (e) {/* privát mód */}
    if (notice) {
      this.$store.commit('app/ADD_ALERT', {
        message: notice,
        style: 'success',
        icon: 'success',
        countdown: 5000
      });
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/authenticated',
      errors: 'user/errors'
    }),
    policy() {
      return this.user?.password_policy || null;
    },
    visible() {
      return !!this.policy?.must_change && !!this.user?.id && !!this.policy?.wording;
    },
    /**
     * A képernyő szövege a SZERVERTŐL jön, abból a válaszból, ami a megjelenését is
     * elrendeli. Ez az egyetlen képernyő, aminek pontosan akkor kell működnie, amikor
     * az alkalmazás a legrosszabb állapotban van — minden más hívás 423, és a
     * fordítás-csomag még be sem töltődött. Mérve: ilyenkor nyers kulcsok jelentek
     * meg, és a lusta kulcs-lekérés egyszerre egyet enged át, tehát percekig azok is
     * maradtak.
     */
    wording() {
      return this.policy?.wording || {};
    }
  },
  methods: {
    async submit() {
      if (this.saving) {
        return;
      }
      this.saving = true;

      // Ugyanaz az út, mint a profil jelszó-csere kártyáján — a hibaüzenetek is
      // ugyanoda kerülnek (`user/errors`), tehát a kettő nem csúszhat szét.
      const saved = await this.$store.dispatch('user/changePassword', Object.assign({}, this.form, {
        id: this.user.id
      }));
      this.saving = false;
      if (!saved) {
        return;
      }

      // Hogy vége-e, azt a szerver mondja meg, nem mi: újratöltjük a bejelentkezett
      // felhasználót, és a képernyő ettől tűnik el.
      this.form = {
        password: null,
        new: null,
        new_confirmation: null
      };
      await this.$store.dispatch('user/authenticated');

      // A csere előtt minden más hívás 423-at kapott (jogok, menü, intézmények), és azokat senki nem kéri újra:
      // a bal menü újratöltésig üres maradt. A friss indulás mindent úgy tölt be, mint egy belépés.
      // Az újraindulás elvinné a sikerüzenetet: a szövegét most tesszük el (most a fordítás biztosan él), az új indulás kiírja.
      if (!this.visible) {
        try {
          window.sessionStorage.setItem(CHANGED_NOTICE_KEY, this.$t('users.password_changed').ucFirst());
        } catch (e) {/* privát mód */}
        window.location.reload();
      }
    },
    logout() {
      this.$store.dispatch('auth/logout');
    }
  }
};